import styled, { css } from 'styled-components';

import * as mx from 'core/styles/mixins';
import { Icon } from 'core/components/Icon/Icon.style';
import { noticeBadge } from '../../../styles/variables';

// -------------------------

export const PRIMARY = noticeBadge.primary;
export const SECONDARY = noticeBadge.secondary;
// -------------------------

export const Wrapper = styled.div<{
	margin?: string;
	hidden: boolean;
}>`
	position: relative;
	border: 1px dashed ${PRIMARY};

	${({ margin }) =>
		margin &&
		css`
			margin: ${margin};
		`}

	${({ hidden }) =>
		hidden &&
		css`
			display: none;
		`}
`;

export const Content = styled.div`
	padding: 5px;
	padding-top: 0;
`;

export const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 5px;
`;

export const Notice = styled.div`
	display: inline-flex;
	align-items: center;
	background-color: ${PRIMARY};
	color: ${SECONDARY};
	border-radius: 15px;
	padding: 2px 6px;
	font-size: 12px;
	cursor: help;
	line-height: 12px;
`;

export const Controls = styled.div`
	display: flex;
	align-items: center;
`;

export const IsCollapsed = styled.span`
	font-size: 10px;
	color: ${PRIMARY};
	margin-right: 5px;
`;

const Button = styled.button`
	${mx.buttonReset}
	${mx.square('25px')}
	color: ${PRIMARY};
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0.5;

	&:hover,
	&:focus {
		opacity: 1;
	}
`;

export const ToggleCollapse = styled(Button)``;

export const Dismiss = styled(Button)`
	&:hover,
	&:focus {
		&:not(:active) {
			${Icon} {
				transform: scale(1.1);
			}
		}
	}
`;
